module.exports = __webpack_public_path__ + "img/pr-13.a4248a4e.png";